export class DisclaimerSection {
    constructor(obj: any = null){
        if(obj){
            this.id = obj.id || "";
            this.htmlDescriptionArray = obj.htmlDescriptionArray || []
        }
    };
    id: string = "";
    htmlDescriptionArray: string[] = [];
}